import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100%;
  background: linear-gradient(-180deg, #fafafa, #fafafa);
  /* padding-bottom: 30px; */
`;
